import { CaseStatusData } from 'ts/types/case-status.types';
import { createAction, getActionList } from './action-utils';
import {
  CASE_STATUS_ERROR,
  CASE_STATUS_START,
  CASE_STATUS_SUCCESS,
  GET_CASE_AND_SERVICE_STATUS,
  GET_SERVICE_STATUS_FAIL,
  GET_SERVICE_STATUS_START,
  GET_SERVICE_STATUS_SUCCESS,
} from './types';

const actions = {
  getCaseAndServiceStatus: (
    caseReference: string,
    navigateToCaseStatus: boolean = true,
  ) =>
    createAction(GET_CASE_AND_SERVICE_STATUS, {
      caseReference,
      navigateToCaseStatus,
    }),
  getCaseStatus: (
    caseReference: string,
    navigateToCaseStatus: boolean = true,
  ) => createAction(CASE_STATUS_START, { caseReference, navigateToCaseStatus }),
  getCaseStatusSuccess: (result: CaseStatusData) =>
    createAction(CASE_STATUS_SUCCESS, result),
  getCaseStatusError: (error: any) => createAction(CASE_STATUS_ERROR, error),
  getServiceStatusStart: ({
    caseReference,
    caseGuid,
  }: {
    caseReference?: string;
    caseGuid?: string;
  }) => createAction(GET_SERVICE_STATUS_START, { caseReference, caseGuid }),
  getServiceStatusFail: (e: any) => createAction(GET_SERVICE_STATUS_FAIL, e),
  getServiceStatusSuccess: (payload: any) =>
    createAction(GET_SERVICE_STATUS_SUCCESS, payload),
};

export default actions;

const actionList = getActionList(actions);

export type CaseStatusActionType = typeof actionList[number];
